export default {
  kicker: 'Konto & alles Weitere',
  title: 'Mehr',
  account: 'Konto',
  logout: 'Abmelden',
  areas: 'Bereiche',
  system: 'System',
  sync: 'Synchronisierung',
  lastSynced: 'Zuletzt synchronisiert',
  running: 'Läuft …',
  now: 'Jetzt',
  season: 'Saison',
  seasonSub: 'Rennen, Wochenraster, Vorschlag',
  health: 'Health',
  healthSub: 'Schlaf, HRV, Ruhepuls, Schritte',
  analysis: 'Analyse',
  analysisSub: 'Effizienz, Form, Zonen',
  maps: 'Karten',
  mapsSub: 'Alle Routen, Heatmap',
  gear: 'Ausrüstung',
  gearSub: 'Schuhe, km, Ausmustern',
  wrapped: 'Wrapped',
  wrappedSub: 'Monats- und Jahresrückblick',
  /** „Oktober ist ab So, 01.11. fertig" */
  wrappedHint: '{month} ist ab {date} fertig',
  settings: 'Einstellungen',
  settingsSub: 'Quellen, Sportarten, Zonen, Sprache',
};
